const PREFILL_KEY = "hospitol.pharmacyPrefill";

export interface PharmacyPrefillLine {
  productId: string;
  quantity: number;
  label: string;
}

export interface PharmacyPrefill {
  patientId: string;
  prescriptionId: string;
  lines: PharmacyPrefillLine[];
}

export function setPharmacyPrefill(prefill: PharmacyPrefill): void {
  sessionStorage.setItem(PREFILL_KEY, JSON.stringify(prefill));
}

export function peekPharmacyPrefill(): PharmacyPrefill | null {
  try {
    const raw = sessionStorage.getItem(PREFILL_KEY);
    return raw ? (JSON.parse(raw) as PharmacyPrefill) : null;
  } catch {
    return null;
  }
}

export function consumePharmacyPrefill(): PharmacyPrefill | null {
  const prefill = peekPharmacyPrefill();
  if (prefill) sessionStorage.removeItem(PREFILL_KEY);
  return prefill;
}
